import { DocumentSelection, DocumentSelectionDto } from "@models/documents/document-selection";
import { DocumentationType, DocumentSelectionType } from "@models/documents/document-enums";

export function getBulkCompanyChangePartyNameDocumentSelection(documentationType: DocumentationType): DocumentSelectionDto {
  const selection: DocumentSelection[] = [];

  if (documentationType == DocumentationType.Minutes) {
    selection.push({
      included: true,
      fileId: "c:484:a2:minutes",
      fileName: "Change of Name Minutes",
      documentType: DocumentSelectionType.Minutes,
      mandatory: false,
      sequence: 3
    });
  } else if (documentationType == DocumentationType.Resolution) {
    selection.push({
      included: true,
      fileId: "c:484:a2:resolution",
      fileName: "Change of Name Resolution",
      documentType: DocumentSelectionType.Resolution,
      mandatory: false,
      sequence: 2
    });
  }

  return { selection };
}
